import"./dist-es/globalVars.js";import s from"./dist-es/subscribe.js";var i="undefined"!=typeof window?s:function(){};export{i as subscribe};
//# sourceMappingURL=index.es.js.map
